import {
  ADD_COLLECTION_MODAL,
  ADD_ENTITIES_TO_NEW_COLLECTION_MODAL,
  ADD_ENTITY_TO_COLLECTION_MODAL,
  ADD_MOVIE_REVIEW_MODAL,
  ADD_SERIES_REVIEW_MODAL,
  ADD_THEATER_TO_LIST,
  DISABLE_ACCOUNT_MODAL,
  ENABLE_ACCOUNT_MODAL,
  ModalNames,
  RATE_MOVIE_MODAL,
  REMOVE_COLLECTION_ENTITY_MODAL,
  REMOVE_COLLECTION_MODAL,
  REVIEW,
  SERIES_PROGRESS,
  SHARE_MODAL,
  SPEED_NOTER_FOLLOW_USER_SUGGESTED_SERIES_MODAL,
  SPEED_NOTER_RATE_TOP_250_MOVIES_MODAL,
  SPEED_NOTER_RATE_USER_SUGGESTED_MOVIES_MODAL,
  SPEED_NOTER_WANT_TO_SEE_SUGGESTED_MOVIES_MODAL
} from 'common/module/ui/lazy-modal/constant-types';

/**
 * Fetches using Webpack dynamic import the given modal module
 *
 * @param {string} modalModuleName The name of the modal module to fetch (must match a known module)
 * @return {Promise} A Promise resolved with the module's default export or rejected (if the module name is not known)
 */
export default async function fetchModalModule(modalModuleName: string) {
  let modalModule;
  switch (modalModuleName) {
    case ADD_SERIES_REVIEW_MODAL:
      modalModule = await import(
        'userspace/routes/MyReviews/Series/AddReviewModal'
      );
      break;
    case ADD_MOVIE_REVIEW_MODAL:
      modalModule = await import(
        'userspace/routes/MyReviews/Movies/AddReviewModal'
      );
      break;
    case RATE_MOVIE_MODAL:
      modalModule = await import('userspace/shared/Modal/RateMovieModal');
      break;
    case ADD_THEATER_TO_LIST:
      modalModule = await import(
        'userspace/routes/MyTheaters/List/AddTheaterModal/index.js'
      );
      break;
    case SPEED_NOTER_RATE_USER_SUGGESTED_MOVIES_MODAL:
      modalModule = await import(
        'userspace/shared/Modal/SpeedNoterModal/RateUserSuggestedMoviesModal'
      );
      break;
    case SPEED_NOTER_RATE_TOP_250_MOVIES_MODAL:
      modalModule = await import(
        'userspace/shared/Modal/SpeedNoterModal/RateTop250MoviesModal'
      );
      break;
    case SPEED_NOTER_FOLLOW_USER_SUGGESTED_SERIES_MODAL:
      modalModule = await import(
        'userspace/shared/Modal/SpeedNoterModal/FollowUserSuggestedSeriesModal'
      );
      break;
    case SPEED_NOTER_WANT_TO_SEE_SUGGESTED_MOVIES_MODAL:
      modalModule = await import(
        'userspace/shared/Modal/SpeedNoterModal/WantToSeeSuggestedMoviesModal'
      );
      break;
    case ModalNames.SPEED_NOTER_WANT_TO_SEE_USER_SUGGESTED_SERIES_MODAL:
      modalModule = await import(
        'userspace/shared/Modal/SpeedNoterModal/WantToSeeUserSuggestedSeriesModal'
      );
      break;
    case REVIEW:
      modalModule = await import('userspace/shared/Modal/ReviewModal');
      break;
    case SERIES_PROGRESS:
      modalModule = await import('userspace/shared/Modal/SeriesProgressModal');
      break;
    case ADD_COLLECTION_MODAL:
      modalModule = await import(
        'userspace/routes/MyCollections/Personal/CollectionModal'
      );
      break;
    case DISABLE_ACCOUNT_MODAL:
      modalModule = await import(
        'userspace/routes/Settings/UpdateProfileForm/DisableAccountModal'
      );
      break;
    case REMOVE_COLLECTION_MODAL:
      modalModule = await import(
        'userspace/routes/MyCollections/Personal/RemoveCollectionModal'
      );
      break;
    case REMOVE_COLLECTION_ENTITY_MODAL:
      modalModule = await import(
        'userspace/routes/MyCollections/Personal/Collection/RemoveCollectionEntityModal'
      );
      break;
    case ADD_ENTITY_TO_COLLECTION_MODAL:
      modalModule = await import(
        'userspace/routes/MyCollections/Personal/AddEntityToCollectionModal'
      );
      break;
    case ADD_ENTITIES_TO_NEW_COLLECTION_MODAL:
      modalModule = await import(
        'userspace/routes/CampaignSpeednoter/CreateCollectionModal'
      );
      break;
    case ENABLE_ACCOUNT_MODAL:
      modalModule = await import('userspace/shared/Modal/EnableAccountModal');
      break;
    case ModalNames.TOS_VALIDATION_MODAL:
      modalModule = await import('common/components/TOSValidationModal');
      break;
    case SHARE_MODAL:
      modalModule = await import('common/components/ShareModal');
      break;
    case ModalNames.SEARCH_RATINGS_MOVIE_MODAL:
      modalModule = await import(
        'userspace/routes/MyMovies/Seen/AddMoviesToSeenModal'
      );
      break;
    case ModalNames.SEARCH_RATINGS_SERIES_MODAL:
      modalModule = await import(
        'userspace/routes/MySeries/MySeries/AddSeriesToMySeriesModal'
      );
      break;
    case ModalNames.SHOWTIME_MODAL:
      modalModule = await import(
        /* webpackChunkName: "showtime-modal" */ 'common/components/ShowtimeModal'
      );
      break;
    case ModalNames.FACEBOOK_ACCOUNT_RECOVERY:
      modalModule = await import(
        'common/components/socialNetworks/FacebookAccountRecoveryModal'
      );
      break;
    case ModalNames.REWIND_MODAL:
      modalModule = await import(
        /* webpackChunkName: "rewind-modal" */ 'common/components/RewindModal'
      );
      break;
    default:
      return Promise.reject(
        new Error(`Unknown modal module ${modalModuleName}`)
      );
  }
  return modalModule.default;
}
